var extractHostname = function extractHostname(url) {
  try {
    return new URL(url).hostname;
  } catch (_unused) {
    return url;
  }
};
export default extractHostname;